export default __webpack_public_path__ + "static/drop-in-0f97e49d66e9238ce8b6791c8a45ef94.png";